// routing
import Routes from 'routes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import Snackbar from 'ui-component/extended/Snackbar';
import ThemeCustomization from 'themes';
import { Helmet } from 'react-helmet-async';
import { GEO_PAGE_DESCRIPTIONS } from 'static/geoPageInfo';

// ==============================|| APP ||============================== //

const App = () => (
    <ThemeCustomization>
        <NavigationScroll>
            <Helmet>
                <title>Hotmob</title>
                <meta name="description" content={GEO_PAGE_DESCRIPTIONS.HOME} />
                <meta property="og:title" content="Hotmob" />
                <meta property="og:description" content={GEO_PAGE_DESCRIPTIONS.HOME} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Hotmob" />
            </Helmet>
            <>
                <Routes />
                <Snackbar />
            </>
        </NavigationScroll>
    </ThemeCustomization>
);

export default App;
